import React, { Component } from "react";

import "./App.css";
import "./queries.css";


import { Layout } from "./containers/layout/layout";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Layout />
      </div>
    );
  }
}

export default App;
